const AUTH_LOGIN_SESSION_KEY_PREFIX = 'auth-login-session:';

export function authLoginSessionStorageKey(userId: string): string {
  return `${AUTH_LOGIN_SESSION_KEY_PREFIX}${userId}`;
}

function getLocalStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function createSessionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `session-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/** Always mint and store a new login session id (call on successful login). */
export function createAuthLoginSessionId(userId: string | null | undefined): string | null {
  if (!userId) return null;
  const storage = getLocalStorage();
  if (!storage) return null;
  try {
    const sessionId = createSessionId();
    storage.setItem(authLoginSessionStorageKey(userId), sessionId);
    return sessionId;
  } catch {
    return null;
  }
}

/** Returns existing login session id for this user, or creates and stores a new one. */
export function getOrCreateAuthLoginSessionId(userId: string | null | undefined): string | null {
  if (!userId) return null;
  const storage = getLocalStorage();
  if (!storage) return null;
  try {
    const key = authLoginSessionStorageKey(userId);
    const existing = storage.getItem(key);
    if (existing) return existing;
    const sessionId = createSessionId();
    storage.setItem(key, sessionId);
    return sessionId;
  } catch {
    return null;
  }
}

export function clearAuthLoginSessionId(userId: string | null | undefined): void {
  if (!userId) return;
  const storage = getLocalStorage();
  if (!storage) return;
  try {
    storage.removeItem(authLoginSessionStorageKey(userId));
  } catch {
    // Private mode — ignore.
  }
}
